import type { AuthCredential } from 'firebase/auth';
import { useCallback, useState } from 'react';

export const useAccountLinking = (setAuthError: (error: string | null) => void) => {
  const [isLinkingMode, setIsLinkingMode] = useState<boolean>(false);
  const [linkingEmail, setLinkingEmail] = useState<string>('');
  const [pendingCred, setPendingCred] = useState<AuthCredential | null>(null);

  const cancelLinking = useCallback(() => {
    setIsLinkingMode(false);
    setLinkingEmail('');
    setPendingCred(null);
    setAuthError(null);
  }, [setAuthError]);

  return {
    isLinkingMode,
    setIsLinkingMode,
    linkingEmail,
    setLinkingEmail,
    pendingCred,
    setPendingCred,
    cancelLinking,
  };
};
